/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Divider, Grid, ProductCard, Typography, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/coding-challenges';

const styles = {
  sections: css`
    /* margin-right: 40px;
    padding: 20px;
    width: 28.75%; */
    padding: 20px;
    align-items: center;
    width: 33.33%;
  `,
  productCards: css`
    text-align: left;
    padding: 10px;
  `,
  highlightText: css`
    color: #0056d2;
  `,
  cardsCenter: css`
    justify-content: center;
    width: 100%;
  `,
  codingSection: css`
    margin-right: 60px;
    margin-left: 60px;
    justify-content: center;
  `,
  titleText: css`
    margin-bottom: 40px;
  `,
};

const LandingPageCodingChallenges = () => {
  return (
    <div css={styles.codingSection}>
      <Typography variant="h1semibold">{_t('Coursera Coding Challenges')}</Typography>
      <Typography2 component="p" css={styles.titleText} variant="bodyPrimary">
        {_t('Demonstrate your job-ready skills with a real-world coding challenge.')}
      </Typography2>
      <Grid container css={styles.cardsCenter}>
        <Grid item css={styles.sections}>
          <ProductCard
            variant="grid"
            productType="competitionRewards"
            width="100%"
            body={
              <div css={styles.productCards}>
                <Typography variant="h2semibold" css={[styles.productCards, styles.highlightText]}>
                  {_t('Solve a problem using real-world data')}
                </Typography>
                <Divider />
                <Typography2 component="p" variant="bodyPrimary" css={styles.productCards}>
                  {_t(
                    'Experience the role of a Data Scientist in a coding exercise that mirrors a real on-the-job scenario,  and work with a real-world dataset.'
                  )}
                </Typography2>
              </div>
            }
          />
        </Grid>
        <Grid item css={styles.sections}>
          <ProductCard
            variant="grid"
            productType="competitionRewards"
            body={
              <div css={styles.productCards}>
                <Typography variant="h2semibold" css={[styles.productCards, styles.highlightText]}>
                  {_t('Gain insight into your performance')}
                </Typography>
                <Divider />
                <Typography2 component="p" css={styles.productCards} variant="bodyPrimary">
                  {_t(
                    'Get feedback on your work from an autograder, an integrated tool trained to evaluate your model in real time. Then compare your performance with other participants.'
                  )}
                </Typography2>
              </div>
            }
          />
        </Grid>
        <Grid item css={styles.sections}>
          <ProductCard
            variant="grid"
            productType="competitionRewards"
            body={
              <div css={styles.productCards}>
                <Typography variant="h2semibold" css={[styles.productCards, styles.highlightText]}>
                  {_t('Share your work with potential employers')}
                </Typography>
                <Divider />
                <Typography2 component="p" css={styles.productCards} variant="bodyPrimary">
                  {_t(
                    'Showcase your skills and technical expertise by adding your project to your Coursera Skills Profile.'
                  )}
                </Typography2>
              </div>
            }
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default LandingPageCodingChallenges;
